<template>
  <div>
    <div class="course-card">
        <div class="left">
            <img src="@img/tag_live.png" class="tag" v-if="item.course_type == 1" alt>
            <div class="cover">
                <img :src="item.img_url?item.img_url:def" class="covers" alt>
                <img src="@img/living0.png" v-if="item.living == '0'" class="state" alt>
                <img src="@img/living1.png" v-if="item.living == '1'" class="state" alt>
                <img src="@img/living2.png" v-if="item.living == '2'" class="state" alt>
                <img src="@img/living3.png" v-if="item.living == '3'" class="state" alt>
                <img src="@img/living4.png" v-if="item.living == '4'" class="state" alt>
            </div>
        </div>
        <div class="right">
            <div class="title">{{item.title}}</div>
            <div class="contents">{{item.brief}}</div>
            <div class="foot">
                <div class="views" v-show="item.viewer_num">
                    <span><img src="@img/eye.png" alt>
                    {{item.viewer_num}}</span>
                    <span><img src="@img/talk.png" alt> {{item.comment_num?item.comment_num:0}}</span>
                    <span :class="item.prime_price==0?'free':'price'">{{item.prime_price==0? item.authority_way == 1 ?'免费': '按视频购买':priceshow == true ? '￥'+item.prime_price : ''}}</span>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      def: require("@img/default_cover.png")
    };
  },
  computed: {
    ...mapState(["priceshow"]),
  },
  methods: {},
  props: ["item"]
};
</script>

<style lang="less" scoped>
.tag {
  position: absolute;
  z-index: 1000;
  left: 12px;
  width: 36px;
  height: 49px;
}
.course-card {
  position: relative;
    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #E5ECF4;
    width: 100%;
    height: 180px;
    /* padding: 12px; */
    -webkit-transition: 0.3s ease all;
    transition: 0.3s ease all;
    background: #fff;
    border-radius: 4px;
    display: flex;
    padding: 17px 17px 17px 14px;
    background: #FFFFFF;
    border: 1px solid #E5ECF4;
    box-shadow: 0 4px 9px 0 rgba(96,96,96,0.11);
  &:hover {
    transform: translateY(-6px);
    -webkit-transform: translateY(-6px);
    -moz-transform: translateY(-6px);
    box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
    -webkit-box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
    -moz-box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
  }
  .cover {
    position: relative;
    flex: 1;
    .covers {
        width: 274px;
        height: 146px;
        border-radius: 4px;
    }
    .state {
      position: absolute;
      width: 70px;
      z-index: 1000;
      right: 0;
      bottom: 0;
    }
  }
  .title {
    margin: 0 0 10px;
    text-align: justify;
    margin-top: 10px;
    margin-bottom: 16px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: 'MicrosoftYaHeiUI';
    font-size: 18px;
    color: #333333;
    letter-spacing: 0;
    line-height: 23px;
    cursor: pointer;
    &:hover {
        color: #033300 ;
    }
  }
  .foot {
    display: flex;
    justify-content: space-between;
    height: 22px;
    line-height: 22px;
    font-size: 12px;
    color: #999;
    margin-top: 15px;
    .views {
      font-size: 12px;
      span {
          margin-right: 20px;
      }
      img {
        width: 16px;
        vertical-align: middle;
        margin-bottom: 4px;
      }
    }
    .price {
      color: #f5a623;
      margin-right: 12px;
    }
    .free {
      color: #43BC60;
      margin-right: 12px;
    }
  }
  .right {
      margin-left: 17px;
      .contents {
        font-family: 'PingFangSC-Regular';
        font-size: 14px;
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
  }
}
</style>
